import { render, staticRenderFns } from "./flex-event-list.vue?vue&type=template&id=2375cd2b&scoped=true&"
import script from "./flex-event-list.vue?vue&type=script&lang=js&"
export * from "./flex-event-list.vue?vue&type=script&lang=js&"
import style0 from "./flex-event-list.vue?vue&type=style&index=0&id=2375cd2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2375cd2b",
  null
  
)

export default component.exports